import { FC } from 'react';
import { RepurchaseCarousel } from '@/components/blocks/DpRepurchaseCoupon/parts/RepurchaseCarousel';
import { RepurchaseCta } from '@/components/blocks/DpRepurchaseCoupon/parts/RepurchaseCta';
import { RepurchaseHero } from '@/components/blocks/DpRepurchaseCoupon/parts/RepurchaseHero';
import { RepurchasePurchase } from '@/components/blocks/DpRepurchaseCoupon/parts/RepurchasePurchase';

export const DpRepurchaseCarousel: FC<{
	title?: string;
	image?: string;
	video?: string;
	imagealt?: string;
	linkhref?: string;
	linklabel?: string;
}> = ({ title, image, video, imagealt, linkhref, linklabel }) => (
	<RepurchaseCarousel
		content={{ title, image, video, alt: imagealt, linkHref: linkhref, linkLabel: linklabel }}
	/>
);

export const DpRepurchaseCta: FC<{
	title?: string;
	text?: string;
	buttonlabel?: string;
	nosizebuttonlabel?: string;
	validitytext?: string;
	sizefacet?: string;
	hrefhombre?: string;
	hrefmujer?: string;
	hrefnino?: string;
}> = ({
	title,
	text,
	buttonlabel,
	nosizebuttonlabel,
	validitytext,
	sizefacet,
	hrefhombre,
	hrefmujer,
	hrefnino,
}) => (
	<RepurchaseCta
		title={title}
		text={text}
		buttonLabel={buttonlabel}
		noSizeButtonLabel={nosizebuttonlabel}
		validityText={validitytext}
		sizeFacet={sizefacet}
		genderHrefs={{ hombre: hrefhombre, mujer: hrefmujer, nino: hrefnino }}
	/>
);

type RepurchaseBannerAttributes = Partial<
	Record<
		| 'eyebrow'
		| 'title'
		| 'text'
		| 'pendingtitle'
		| 'pendingtext'
		| 'guesttitle'
		| 'guesttext'
		| 'titletoday'
		| 'titletomorrow'
		| 'countdownlabel'
		| 'activatebuttonlabel'
		| 'guestbuttonlabel'
		| 'cardlabel'
		| 'cardnote'
		| 'terms',
		string
	>
>;

export const DpRepurchaseBanner: FC<RepurchaseBannerAttributes> = ({
	eyebrow,
	title,
	text,
	pendingtitle,
	pendingtext,
	guesttitle,
	guesttext,
	titletoday,
	titletomorrow,
	countdownlabel,
	activatebuttonlabel,
	guestbuttonlabel,
	cardlabel,
	cardnote,
	terms,
}) => (
	<RepurchaseHero
		eyebrow={eyebrow}
		title={title}
		text={text}
		pendingTitle={pendingtitle}
		pendingText={pendingtext}
		guestTitle={guesttitle}
		guestText={guesttext}
		titleToday={titletoday}
		titleTomorrow={titletomorrow}
		countdownLabel={countdownlabel}
		activateButtonLabel={activatebuttonlabel}
		guestButtonLabel={guestbuttonlabel}
		cardLabel={cardlabel}
		cardNote={cardnote}
		terms={terms}
	/>
);

export const DpRepurchasePurchase: FC<{
	eyebrow?: string;
	text?: string;
}> = ({ eyebrow, text }) => <RepurchasePurchase eyebrow={eyebrow} text={text} />;
